import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import {
  getNewHireDataStart,
  setNewHireDepartment,
  setNewHirePosition,
  setGoogleGroups,
  setAzureGroups,
  setNewHireLocalDistros,
  setNoc,
  setNavitaire,
  setUber,
  setLyft,
} from '../../redux/new-hire/new-hire.actions';
import { selectCurrentUser } from '../../redux/user/user.selector';
import {
  selectDepartments,
  selectNewHireDepartment,
  selectNewHirePosition,
} from '../../redux/new-hire/new-hire.selector';
import Multiselect from 'multiselect-react-dropdown';
import { Container } from '@mui/material';
import './newhire-page.styles.scss';
import NewHireForm from '../../components/newhire-form/newhire-form.component';

const NewHirePage = ({
  _currentUser,
  dispatchGetNewHireDataStart,
  departments,
  currDepartment,
  currPosition,
  setNewHireDepartment,
  setNewHirePosition,
  setNewHireAzureGroups,
  setNewHireGoogleGroups,
  setNewHireLocalDistros,
  setNocObj,
  setNavitaireObj,
  setUberObj,
  setLyftObj,
}) => {
  const [positions, setPositions] = useState(null);

  const departmentMultiselectRef = useRef(null);
  const positionMultiselectRef = useRef(null);

  useEffect(() => {
    dispatchGetNewHireDataStart();
  }, [dispatchGetNewHireDataStart]);

  useEffect(() => {
    if (departmentMultiselectRef.current !== null) {
      let selectedDepartments =
        departmentMultiselectRef.current.getSelectedItems();
      if (selectedDepartments.length >= 1) {
        setPositions(selectedDepartments[0].positions);
      }
    }
  }, [departmentMultiselectRef]);

  const onDepartmentSelect = (_selectedList, selectedItem) => {
    setNewHireDepartment(selectedItem.name);
    setPositions(selectedItem.positions);
  };
  const onDepartmentRemove = () => {
    setPositions(null);
    setNewHireDepartment(null);
    setNewHirePosition(null);
    setNewHireGoogleGroups(null);
    setNewHireAzureGroups(null);
    setNocObj(null);
    setNavitaire(null);
  };

  const onPositionSelect = (_selectedList, selectedItem) => {
    setNewHirePosition(selectedItem.title);
    setNewHireGoogleGroups(selectedItem.googleGroups);
    setNewHireAzureGroups(selectedItem.microsoftGroups);
    setNocObj(selectedItem.raido);
    setNavitaireObj(selectedItem.navitaire);
    setUberObj(selectedItem.uber);
    setLyftObj(selectedItem.lyft);
  };

  const onPositionRemove = () => {
    setNewHirePosition(null);
    setNewHireGoogleGroups(null);
    setNewHireAzureGroups(null);
    setNewHireLocalDistros(null);
    setNocObj(null);
    setNavitaire(null);
    setUber(null);
    setLyft(null);
  };

  return (
    <Container
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        padding: '20px',
        backgroundColor: '#FFEBE6',
        borderRadius: '20px',
        boxShadow: '0px 0px 33px 25px #FF7575',
      }}
    >
      <h4 style={{ textAlign: 'center' }}>NEW HIRE FORM</h4>
      <Container
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          padding: '20px',
        }}
      >
        <span>
          {departments && (
            <>
              <label> Departments:</label>
              <Multiselect
                isObject={true}
                options={departments}
                displayValue="name"
                selectionLimit={1}
                hidePlaceholder={true}
                avoidHighlightFirstOption={true}
                selectedValues={departments.filter(
                  (department) => department.name === currDepartment
                )}
                ref={departmentMultiselectRef}
                placeholder="Select a Department"
                onSelect={onDepartmentSelect}
                onRemove={onDepartmentRemove}
                style={{
                  chips: {
                    background: 'red',
                    color: 'white',
                    fontWeight: 'bold',
                  },
                  option: { fontSize: '15px' },
                  searchBox: {
                    backgroundColor: 'white',
                    border: '1px solid black',
                  },
                  groupHeading: {
                    fontWeight: 'bold',
                    color: 'white',
                    fontSize: '20px',
                    backgroundColor: 'red',
                    padding: '3px',
                  },
                  optionContainer: {
                    // To change css for option container
                    height: '200px',
                  },
                }}
              />
            </>
          )}
        </span>

        <span>
          {positions && (
            <>
              <label> Positions:</label>

              <Multiselect
                isObject={true}
                options={positions}
                displayValue="title"
                onSelect={onPositionSelect}
                onRemove={onPositionRemove}
                selectedValues={positions.filter(
                  (position) => position.title === currPosition
                )}
                preSelectedValues={positions.filter(
                  (position) => position.title === currPosition
                )}
                ref={positionMultiselectRef}
                selectionLimit={1}
                hidePlaceholder={true}
                placeholder="Select a Position"
                avoidHighlightFirstOption={true}
                style={{
                  chips: {
                    background: 'red',
                    color: 'white',
                    fontWeight: 'bold',
                  },
                  option: { fontSize: '15px' },
                  searchBox: {
                    backgroundColor: 'white',
                    border: '1px solid black',
                  },
                  groupHeading: {
                    fontWeight: 'bold',
                    color: 'white',
                    fontSize: '20px',
                    backgroundColor: 'red',
                    padding: '3px',
                  },
                  optionContainer: {
                    // To change css for option container
                    height: '200px',
                  },
                }}
              />
            </>
          )}
        </span>
      </Container>
      <Container
        sx={{
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        {currDepartment && currPosition && <NewHireForm />}
      </Container>
    </Container>
  );
};

const mapStateToProps = createStructuredSelector({
  currentUser: selectCurrentUser,
  departments: selectDepartments,
  currDepartment: selectNewHireDepartment,
  currPosition: selectNewHirePosition,
});

const mapDispatchToProps = (dispatch) => ({
  dispatchGetNewHireDataStart: () => dispatch(getNewHireDataStart()),
  setNewHireDepartment: (department) =>
    dispatch(setNewHireDepartment(department)),
  setNewHirePosition: (position) => dispatch(setNewHirePosition(position)),
  setNewHireGoogleGroups: (googleGroups) =>
    dispatch(setGoogleGroups(googleGroups)),
  setNewHireAzureGroups: (azureGroups) => dispatch(setAzureGroups(azureGroups)),
  setNewHireLocalDistros: (localDistros) =>
    dispatch(setNewHireLocalDistros(localDistros)),
  setNocObj: (obj) => dispatch(setNoc(obj)),
  setNavitaireObj: (obj) => dispatch(setNavitaire(obj)),
  setUberObj: (obj) => dispatch(setUber(obj)),
  setLyftObj: (obj) => dispatch(setLyft(obj)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NewHirePage);
